import { Store } from '@ppl/store';
import type { Actions } from './core.actions';
import type { CoreState } from './core.reducer';

export class CoreStore extends Store<CoreState, Actions> {}
